import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { DocumentsComponent } from './documents.component';
import { DocumentsRoutingModule } from './documents-routing.module';
import { TranslateModule } from '@ngx-translate/core';
import { MaterialModule } from '../../../../shared/src/lib/material.module';
import { FeatureModule } from '../../../../shared/src/lib/feature/feature.module';
import { DocumentService } from '../../../../shared/src/lib/service/document.service';
import { MomentModule } from 'ngx-moment';
import { DirectiveModule } from '../../../../shared/src/lib/directive/directive.module';

@NgModule({
  imports: [
    CommonModule,
    DocumentsRoutingModule,
    MaterialModule,
    FeatureModule,
    MomentModule,
    DirectiveModule,
    TranslateModule.forRoot()
  ],
  declarations: [DocumentsComponent],
  providers: [DocumentService]
})
export class DocumentsModule { }
